"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var stimulus_1 = require("stimulus");
var DEFAULT_LABELS = { open: 'ー閉じる', closed: '＋もっと見る' };
var LinksAccordionController = /** @class */ (function (_super) {
    __extends(LinksAccordionController, _super);
    function LinksAccordionController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isOpen = false;
        return _this;
    }
    LinksAccordionController.prototype.connect = function () {
        this.isOpen = this.element.classList.contains('is-open');
        this.updateToggleText();
        this.updateAriaExpanded();
    };
    LinksAccordionController.prototype.toggle = function (e) {
        e.preventDefault();
        this.isOpen = !this.isOpen;
        this.element.classList.toggle('is-open', this.isOpen);
        this.contentTarget.style.maxHeight = this.isOpen ? "".concat(this.contentTarget.scrollHeight, "px") : '';
        this.updateToggleText();
        this.updateAriaExpanded();
    };
    LinksAccordionController.prototype.updateToggleText = function () {
        var _a, _b;
        if (!this.toggleTextTarget) {
            return;
        }
        var open = (_a = this.openTextValue) !== null && _a !== void 0 ? _a : DEFAULT_LABELS.open;
        var closed = (_b = this.closedTextValue) !== null && _b !== void 0 ? _b : DEFAULT_LABELS.closed;
        this.toggleTextTarget.textContent = this.isOpen ? open : closed;
    };
    LinksAccordionController.prototype.updateAriaExpanded = function () {
        this.toggleButtonTarget.setAttribute('aria-expanded', String(this.isOpen));
    };
    LinksAccordionController.targets = ['content', 'toggleText', 'toggleButton'];
    LinksAccordionController.values = {
        openText: { type: String, default: DEFAULT_LABELS.open },
        closedText: { type: String, default: DEFAULT_LABELS.closed },
    };
    return LinksAccordionController;
}(stimulus_1.Controller));
exports.default = LinksAccordionController;
